











import {Component, Vue, Watch} from 'vue-property-decorator';
import {SnackColorType, SnackType} from '@/store';

@Component
export default class SnackbarTemplate extends Vue {
    show: boolean = false;
    message: string = '';
    color: SnackColorType | '' = '';

    @Watch('$store.state.snack') onSnackChanged(newSnack: SnackType) {
        this.message = newSnack.message;
        this.color = newSnack.color || 'error';
        this.show = true;
    }
}
